export interface DeviceInfo {
  url: string;
  path: string;
  search: string;
  userAgent: string;
  viewport: string;
  screenResolution: string;
  devicePixelRatio: number;
  language: string;
  timeZone: string;
  timestamp: string;
}

export const getDeviceInfo = (): DeviceInfo => {
  if (typeof window === 'undefined') {
    return {
      url: '',
      path: '',
      search: '',
      userAgent: '',
      viewport: '',
      screenResolution: '',
      devicePixelRatio: 1,
      language: '',
      timeZone: '',
      timestamp: new Date().toISOString(),
    };
  }

  return {
    url: window.location.href,
    path: window.location.pathname,
    search: window.location.search,
    userAgent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    screenResolution: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    devicePixelRatio: window.devicePixelRatio || 1,
    language: navigator.language || 'en',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    timestamp: new Date().toISOString(),
  };
};
